import type { UserDataLoginRecord } from '@navio/nsdk';
import { type UserSessionData } from '../../contexts/AuthContext';
import { type UserRoleType } from '../../types/roles';
import { hasValidPermission } from '../../utils/validator';

type FinalizeLoginSessionArgs = {
  session: UserSessionData;
  loginUser: (data: UserSessionData) => void;
  requiredLoginLevels?: UserRoleType[];
  accessDeniedMessage: string;
  onAccessDenied: (message: string) => void;
  trackUserIdentity?: (user: UserDataLoginRecord) => void;
  onLoginSuccess?: (userData: UserSessionData) => void;
};

/** Permission check + session write + optional tracking/navigation callbacks. */
export const finalizeLoginSession = ({
  session,
  loginUser,
  requiredLoginLevels,
  accessDeniedMessage,
  onAccessDenied,
  trackUserIdentity,
  onLoginSuccess
}: FinalizeLoginSessionArgs): boolean => {
  if (requiredLoginLevels && !hasValidPermission(requiredLoginLevels, session.user)) {
    onAccessDenied(accessDeniedMessage);
    return false;
  }
  loginUser(session);
  trackUserIdentity?.(session.user);
  onLoginSuccess?.(session);
  return true;
};
